import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import { getStoresByPage } from '../../ApiServices/MessageStoreServices';
import { t } from 'i18next';

export const initialState = {
  value: { totalCount: -1, data: [{}], name: [{}] },
  loading: false,
  error: null,
  rowsPerPage: 10,
  pageNo: 0,
  selectedValue: null,
  sortBy: '',
  sortDirection: 0,
  name: []
};

const storesSlice = createSlice({
  name: 'stores',
  initialState: initialState,
  reducers: {
    clearStoresState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
      state.name = [];
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchAllStores.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value = action?.payload?.data;
      state.pageNo = action?.meta?.arg?.page;
      state.rowsPerPage = action?.meta?.arg?.limit;
      state.sortBy = action?.meta?.arg?.sortBy;
      state.sortDirection = action?.meta?.arg?.sortDirection;
      state.name = action?.payload?.data?.data;
    });
    builder.addCase(fetchAllStores.rejected, (state: any, action: any) => {
      state.loading = false;
      state.error = action?.payload?.data;
      state.name = initialState.name;
    });
  }
});

export const allstoresState = (state: RootState) => state?.allStores;
export const { clearStoresState } = storesSlice.actions;
export default storesSlice.reducer;

export const fetchAllStores = createAsyncThunk(
  'suppliers/fetchStores',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_STORES') }));
      return fulfillWithValue(await getStoresByPage(payload));
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
